import { useState } from "react";

function EndDate(props) {

  const [endDate, setEndDate] = useState(props.coursesObj.EndDate);
  const name = "EndDate";

  function handleStateChange (e) {
  let coursesObj = props.coursesObj;
    props.setCoursesObj({
      ...coursesObj,
      EndDate: e.target.value,
      default: false,
    });
    setEndDate(e.target.value);
  }

  return (
      <>
        <label htmlFor="endDate" className="majorLabel">Date the Class Ends By:</label>
        <input
            type="date"
            id="endDate"
            name={name}
            value={endDate}
            onChange={handleStateChange}
            className="selectBox dayTimeBox"
        />
      </>
  );
}

export default EndDate;
